<template>

<div >
    


 <router-view />

 
</div>
</template>

<script>



import userService from "@/Services/user";

import {
    useUserStore
} from '../stores/user'
import {
    useConfigStore
} from '../stores/config'
import {
    useInfoStore
} from '../stores/info'

import infosistem from "@/Services/infosistem";
export default {
    name: "Root",
    components: {

    },
    mixins: [infosistem],
    setup() {},
    mounted() {
        this.get_info();

    },
    methods: {

        async get_info() {
            console.log('data------')
            let data = await infosistem.GET().then((response) => {
                if (response != null && !response.hasOwnProperty('error')) {
                    let infov = {};
                    response.forEach(element => {
                        infov[element.id] = element.valor;
                    });
                    this.infoset.set(
                        infov
                    );
                   
                }
            });
        },
        showMenu1(id) {
            let actual = false;
            if ($('#' + id).hasClass('hidden')) {
                actual = true;
            }

            $('.genmen').removeClass('hidden');

            $('.genmen').addClass('hidden');
            // let menu1 = document.getElementById(id);
            let icon1 = document.getElementById("icon" + id);
            let menu1 = document.getElementById(id);
            if (actual) {

                $('#' + id).removeClass('hidden');
                //$('#icon'+id).addClass('hidden');
                //$('#'+id).addClass('hidden');
            } else {

                //$('#'+id).removeClass('hidden');
                //$('#icon'+id).addClass('hidden');
                $('#' + id).addClass('hidden');
            }
            icon1.classList.toggle("rotate-180");
        },

        showMenu2(flag) {
            let menu2 = document.getElementById("menu2");

            if (flag) {
                icon2.classList.toggle("rotate-180");
                menu2.classList.toggle("hidden");
            }
        },

        showMenu3(flag) {
            let menu3 = document.getElementById("menu3");
            if (flag) {
                icon3.classList.toggle("rotate-180");
                menu3.classList.toggle("hidden");
            }
        },
        years() {
            const year = new Date().getFullYear()
            return Array.from({
                length: year - 1900
            }, (value, index) => 1901 + index)
        },
        validateEmail(value) {
            if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
                this.msg['email'] = '';
            } else {
                this.msg['email'] = 'Invalid Email Address';
            }
        },

    }
};
</script>

<style scoped>

</style>
